import api from "../../utils/api";

/** GET connection status. Returns {connected, businessName, ...} */
export async function fetchJamedaStatus() {
  const data = await api.get("/api/integrations/jameda/connection/", {
    auth: true,
  });
  return {
    connected: Boolean(data.connected),
    businessId: data.jameda_business_id || "",
    businessName: data.business_name || "",
    lastSynced: data.last_synced || null,
    lastError: data.last_error || "",
    reviewCount: data.review_count ?? data.synced_review_count ?? null,
    averageRating: data.average_rating ?? null,
    locationId: data.location_id ?? null,
  };
}

/** POST credentials → validates against Jameda, stores, runs initial sync. */
export async function connectJameda({ businessId, apiKey }) {
  const data = await api.post(
    "/api/integrations/jameda/connection/",
    { jameda_business_id: businessId, jameda_api_key: apiKey },
    { auth: true }
  );
  const sync = data.sync_result || {};
  return {
    connected: Boolean(data.connected),
    businessName: data.business_name || sync.business_name || "",
    reviewCount: sync.review_count ?? null,
    averageRating: sync.average_rating ?? null,
    locationId: sync.location_id ?? null,
  };
}

export async function disconnectJameda() {
  return api.delete("/api/integrations/jameda/connection/", { auth: true });
}

export async function syncJameda() {
  return api.post("/api/integrations/jameda/sync/", {}, { auth: true });
}
